(() => {
  const visible = element => element?.isConnected && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
  let status;
  const getStatus = () => {
    if (status?.isConnected) return status;
    status = document.createElement('p');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    document.body.append(status);
    return status;
  };
  window.ClikeaCartUX = {
    cartQuantity(errorMessage) {
      return {
        button_loading: false,
        clc_custom: false,
        clc_error: '',
        clc_up: false,
        clc_height: 320,
        clc_restore_focus: false,
        clcRestoreFocus() {
          if (!this.clc_restore_focus || this.cart_loading || this.button_loading) return;
          this.clc_restore_focus = false;
          this.$nextTick(() => {
            const menu = this.$refs.clcMenu;
            if (menu?.isConnected && !menu.open && !document.hidden && (document.activeElement === document.body || menu.contains(document.activeElement))) menu.querySelector('summary').focus({preventScroll:true});
          });
        },
        clcPosition(menu) {
          if (!menu.open) { this.clc_custom = false; return; }
          this.$nextTick(() => {
            const r = menu.querySelector('summary').getBoundingClientRect();
            const below = (window.visualViewport?.height || innerHeight) - r.bottom - 90;
            const above = r.top - 105;
            this.clc_up = below < 260 && above > below;
            this.clc_height = Math.max(110, Math.min(320, (this.clc_up ? above : below) - 10));
          });
        },
        async clcSetQuantity(value, input) {
          if (this.button_loading || this.cart_loading) return false;
          const wanted = Number(value);
          this.clc_error = '';
          if (!Number.isSafeInteger(wanted) || wanted < 1 || (input && !input.checkValidity())) {
            this.clc_error = errorMessage;
            input?.reportValidity();
            return false;
          }
          this.button_loading = true;
          try {
            const ok = await this.changeCartItemQuantity(this.item.key, wanted, false, false);
            if (!ok) { this.clc_error = errorMessage; return false; }
            this.$refs.clcMenu.open = false;
            this.clc_custom = false;
            this.clc_restore_focus = true;
            return true;
          } finally {
            this.button_loading = false;
          }
        }
      };
    },

    beginQuantity(key) {
      const focus = document.activeElement;
      const line = focus?.closest('.clc-cart-line,.clc-drawer-item') || [...document.querySelectorAll('[data-clc-line-key]')].find(node => node.dataset.clcLineKey === key && visible(node));
      const picker = line?.querySelector('[data-clc-quantity-summary]');
      const anchor = visible(picker) ? picker : line?.querySelector('input[type=number]');
      if (!anchor) return () => {};
      const top = anchor.getBoundingClientRect().top;
      const scroller = line.closest('.clc-drawer__main');
      let cancelled = false;
      let timer;
      const detach = () => {
        clearTimeout(timer);
        window.removeEventListener('wheel',cancel);
        window.removeEventListener('touchmove',cancel);
        document.removeEventListener('keydown',navigation);
        document.removeEventListener('visibilitychange',hidden);
      };
      const cancel = () => {cancelled = true;detach();};
      const navigation = event => {if (['PageDown','PageUp','Home','End','ArrowDown','ArrowUp','Tab'].includes(event.key)) cancel();};
      const hidden = () => {if (document.hidden) cancel();};
      window.addEventListener('wheel',cancel,{passive:true});
      window.addEventListener('touchmove',cancel,{passive:true});
      document.addEventListener('keydown',navigation);
      document.addEventListener('visibilitychange',hidden);
      timer = setTimeout(cancel,15000);
      return () => {
        detach();
        if (cancelled || document.hidden || !anchor.isConnected) return;
        if (document.activeElement !== focus && document.activeElement !== document.body) return;
        const delta = anchor.getBoundingClientRect().top - top;
        if (Math.abs(delta) > 1) {
          if (scroller) scroller.scrollTop += delta;
          else window.scrollBy({top:delta,behavior:'instant'});
        }
        if (line.contains(focus) && focus?.isConnected && document.activeElement === document.body) requestAnimationFrame(() => {
          if (!document.hidden && focus.isConnected && !focus.disabled && document.activeElement === document.body) focus.focus({preventScroll:true});
        });
      };
    },

    beginRemove(button, name) {
      const scope = button.closest('.clu-cart-page, [role="dialog"]') || button.closest('.clc-drawer-item')?.parentElement || document;
      const index = [...scope.querySelectorAll('[data-clux-cart-remove]')].filter(visible).indexOf(button);
      const restoreFocus = document.activeElement === button;
      getStatus().textContent = '';
      return () => {
        getStatus().textContent = `${name} eliminado del carrito.`;
        if (!restoreFocus) return;
        let finished = false;
        const cleanup = () => {
          finished = true;
          observer.disconnect();
          clearTimeout(deadline);
          document.removeEventListener('visibilitychange', hidden);
        };
        const hidden = () => { if (document.hidden) cleanup(); };
        const focusWhenReady = () => {
          if (finished || document.body.dataset.cluxCartBusy === 'true') return;
          requestAnimationFrame(() => {
            if (finished || document.body.dataset.cluxCartBusy === 'true') return;
            const remaining = [...scope.querySelectorAll('[data-clux-cart-remove]')].filter(visible);
            const target = remaining[Math.min(Math.max(index, 0), remaining.length - 1)] || [...scope.querySelectorAll('h1, h2, button, a')].find(visible);
            if (!target) return;
            cleanup();
            if (document.activeElement !== document.body && document.activeElement !== button && document.activeElement.isConnected) return;
            if (/^H[12]$/.test(target.tagName)) target.tabIndex = -1;
            target.focus();
          });
        };
        const observer = new MutationObserver(focusWhenReady);
        const deadline = setTimeout(cleanup, 5000);
        observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'data-clux-cart-busy']});
        document.addEventListener('visibilitychange', hidden);
        focusWhenReady();
      };
    }
  };
})();

(() => {
  const bar = document.querySelector('[data-clc-mobile-pay]');
  if (!bar) return;
  function sync() {
    const editable = document.activeElement?.matches('input,textarea,select,[contenteditable=true]');
    const keyboard = window.visualViewport && innerHeight - visualViewport.height > 150;
    document.body.classList.toggle('clc-cart-editing',Boolean(editable || keyboard));
    const shown = getComputedStyle(bar).display !== 'none' && bar.getClientRects().length > 0;
    document.body.classList.toggle('clc-mobile-pay-visible',Boolean(shown));
  }
  document.body.classList.add('clc-mobile-pay-ready');
  document.addEventListener('focusin',sync);
  document.addEventListener('focusout',() => requestAnimationFrame(sync));
  document.addEventListener('visibilitychange',sync);
  window.addEventListener('resize',sync);
  window.visualViewport?.addEventListener('resize',sync);
  new MutationObserver(sync).observe(bar,{attributes:true,attributeFilter:['style']});
  new ResizeObserver(sync).observe(bar);
  sync();
})();
